import React from 'react';
import { useFieldAuth } from '../../contexts/FieldContext';
import NotFoundPage from '../../pages/NotFoundPage';

interface FieldRouteProps {
  children: React.ReactNode;
}

const FieldRoute: React.FC<FieldRouteProps> = ({ children }) => {
  const { field, initializing } = useFieldAuth();

  // Ждем завершения инициализации
  if (initializing) {
    return <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: "'Courier New', monospace",
      color: '#00cc00',
      backgroundColor: '#000'
    }}>
      LOADING FIELD DATA...
    </div>;
  }

  if (!field) {
    return <NotFoundPage />;
  }

  return <>{children}</>;
};

export default FieldRoute;